import axios from 'axios'
import router from '@/router';
import api from '@/api';

export const terminalsModule = {
    namespaced: true,

    state:() => ({
        isLoading: true,
        points_of_sale: null,
    }),

    mutations: {
    },

    actions: {
        async getProjects({}) {
            return axios
            .get(api + "projects/", {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                for(let i = 0; i < response.data.length; i++) {
                    response.data[i].label = response.data[i].name
                    response.data[i].value = response.data[i].code
                }

                return response.data
            })
            .catch((error) => {
                console.log(error);
            });
        },

        async getPointOfSale({}) {
            return axios
            .get(api + "projects/tcode/shops/", {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                for(let i = 0; i < response.data.length; i++) {
                    response.data[i].label = response.data[i].name
                    response.data[i].value = response.data[i].code
                }

                return response.data
            })
            .catch((error) => {
                console.log(error);
            });
        },

        async getDevices({}, data) {
            const project = data?.project || router.currentRoute.value.query.project || router.currentRoute.value.params.project;
            const shop = data?.shop || router.currentRoute.value.query.shop || router.currentRoute.value.params.shop;

            if(!shop || !project) return

            try {
                const response = await axios.get(`${api}projects/${project}/shops/${shop}/devices/`, {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                return response.data
            } catch (error) {
                console.log(error)
            }
        },
        
        async fetchActions({}, customQuery) {
            const project = router.currentRoute.value.query.project || router.currentRoute.value.params.project;
            const shop = router.currentRoute.value.query.shop || router.currentRoute.value.params.shop;
            const action_type = router.currentRoute.value.query.action_type || router.currentRoute.value.params.action_type;
            const device = router.currentRoute.value.query.device || router.currentRoute.value.params.device;
            const order = router.currentRoute.value.query.order || router.currentRoute.value.params.order;

            return axios
                .get(`${api}projects/${project}/shops/${shop}/actions/`, {
                    params: {
                        action_type: action_type,
                        device: device,
                        order: order
                    },
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                .then((response) => {
                    return response.data.results;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        async returnPayment({}, id) {
            const project = router.currentRoute.value.query.project || router.currentRoute.value.params.project;
            const shop = router.currentRoute.value.query.shop || router.currentRoute.value.params.shop;
            try {
                const response = await axios.patch(`${api}projects/${project}/shops/${shop}/actions/${id}/`, {
                    action_type: 'return'
                }, {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                console.log(response.data)
                return response
            } catch (error) {
                console.log(error)
            }
        }
    }
}